<template>
    <div class="card" v-if="$canIf('ritrunk.store')">
        <form action="" method="post" @submit.prevent="createTrunk" id="trunk-form">
            <div class="card-header">
                <div class="d-flex">
                    <h4>Cadastrar Tronco</h4>
                </div>
            </div>
            <div class="card-body">
                <trunk-form
                :errors="errors"
                :trunk="trunk"
                />
            </div>
            <div class="card-footer">
                <button class="btn bg-success mr-2">Cadastrar</button>
                <router-link :to="{ name: 'IntTrunks.Index' }" class="btn bg-danger">Voltar</router-link>
            </div>
        </form>
    </div>
</template>

<script>
import  TrunkForm from "@/components/views/trunks/_Form";
export default {

    components: {
        'trunk-form': TrunkForm,
    },

    props: [
        'route_id'
    ],

    data(){
        return {
            errors: {},
            trunk: {},
        }
    },

    methods: {
        createTrunk() {
            var dados = new FormData(document.getElementById('trunk-form'));

            this.$httpApi.post('troncos/store',dados,{
                headers: {
                    'Authorization': 'Bearer '+sessionStorage.getItem('Auth_Token'),
                },
            }).then(res => {
                var dados = {
                    idRoute: this.route_id,
                    idTrunk: res.data.dados.idTrunk,
                }
                this.$httpApi.post('routesinthavetrunk/store', dados, {
                    headers: {
                        'Authorization': 'Bearer '+sessionStorage.getItem('Auth_Token'),
                    },
                }).then(res => {
                    this.$router.push({ name: 'IntTrunks.Index' })
                    this.$store.dispatch('criarMensagem',[
                        res.data.message,
                        'success'
                    ])
                }).catch(res => {
                    this.$router.push({ name: 'IntTrunks.Index' })
                    if(res.response.data.errors){
                        this.errors = res.response.data.errors
                    }
                    this.$store.dispatch('exibeErro', [
                        res.response
                    ])
                })
                
            }).catch(res => {
                if(res.response.data.errors){
                    this.errors = res.response.data.errors
                }
                this.$store.dispatch('exibeErro', [
                    res.response
                ])
            });
        },
    }

}
</script>

<style>

</style>